/* gallery-height-guard.js — the PDP gallery keeps ONE height.
 *
 * The stock gallery is a <scroll-carousel adaptive-height>: its height follows
 * the ACTIVE slide. That was invisible while every product photo shared a
 * shape — but Agilite Media now adds 3:4 portrait media to products whose
 * classic photos are landscape, so the gallery (and the whole page under it)
 * jumped taller on those slides (Dorian, live magnetix, 2026-08-24).
 *
 * The guard: read each gallery's own image ratios (Shopify renders width/
 * height attributes, so no loading is needed), take the MEDIAN — that IS the
 * "old size", because the classic photos outnumber the newcomers — and lock
 * every slide to it. Taller media letterboxes inside via object-fit: contain.
 * A gallery whose media is already uniform (within 5%) is left byte-for-byte
 * alone, so products without mixed shapes never change.
 *
 * Isolated by design: own file, no theme edits beyond the script tag, reads
 * only the DOM. Remove the file and the gallery is exactly as before.
 */
(function () {
  'use strict';

  function guard() {
    var carousels = document.querySelectorAll('.product-gallery__carousel');
    for (var c = 0; c < carousels.length; c++) {
      var medias = carousels[c].querySelectorAll('.product-gallery__media:not([hidden])');
      var ratios = [];
      for (var i = 0; i < medias.length; i++) {
        var img = medias[i].querySelector('img');
        if (!img) continue;
        var w = parseInt(img.getAttribute('width'), 10);
        var h = parseInt(img.getAttribute('height'), 10);
        if (w > 0 && h > 0) ratios.push(h / w);
      }
      if (ratios.length < 2) continue;
      var sorted = ratios.slice().sort(function (a, b) { return a - b; });
      var median = sorted[Math.floor(sorted.length / 2)];
      var max = sorted[sorted.length - 1];
      if (!median || max / median < 1.05) continue;   // uniform: leave untouched
      for (var j = 0; j < medias.length; j++) {
        var m = medias[j];
        m.style.aspectRatio = (1 / median).toFixed(4);
        m.style.overflow = 'hidden';
        var el = m.querySelector('img, video, iframe');
        if (el) {
          el.style.width = '100%';
          el.style.height = '100%';
          el.style.objectFit = 'contain';
        }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', guard);
  } else {
    guard();
  }
})();
